import React from 'react';

// Number of placeholders - can be the same or different
const NUM_PLACEHOLDERS_START = 15;
// Shared placeholder style from above, or define separately if different dimensions needed
const PLACEHOLDER_STYLE = {
  minWidth: '20px',
  marginRight: '10px',
  height: '30px', // Match typical item height roughly for emission timeline
  opacity: 0.5,
  display: 'flex',
  flexShrink: 0,
  // background: 'rgba(128,128,128,0.1)', // For debugging
};

const EmissionTimeline = ({ temperatureData = [], currentHour, timelineRef, currentItemRef }) => {
  const iconBaseSize = 17;
  const currentHourIconSize = 19;
  const itemBasePadding = '3px';
  const currentHourItemPadding = '5px';
  const scrollableMaxHeight = '70px'; // Adjusted maxHeight slightly, review if needed

  const startPlaceholders = Array.from({ length: NUM_PLACEHOLDERS_START }, (_, i) => ({
    id: `ph-start-emission-${i}`,
    isPlaceholder: true,
  }));

  const combinedItems = [
    ...startPlaceholders,
    ...temperatureData.map((item, index) => ({
      ...item,
      originalIndex: index,
      isPlaceholder: false,
    })),
  ];

  return (
    <div className='slide-in-left-transition'>
      <div
        ref={timelineRef}
        style={{
          display: 'flex',
          overflowX: 'hidden',
          height: '70px',
          whiteSpace: 'nowrap',
          border: '3px solid #009DDC',
          backgroundColor: 'rgba(0, 35, 102, 0.5)',
          backdropFilter: 'blur(15px)',
          padding: '5px',
          borderRadius: '13px',
        }}
      >
        {combinedItems.map((item, combinedIndex) => {
          if (item.isPlaceholder) {
            return <div key={item.id} style={PLACEHOLDER_STYLE}> </div>;
          }

          // Actual data item
          const isCurrent = item.originalIndex === currentHour;
          const emissionLevel = Math.max(1, Math.round(item.emissionFactor / 70));

          return (
            <div
              key={`emission-item-${item.originalIndex}`}
              ref={isCurrent ? currentItemRef : null}
              style={{
                minWidth: '5px',
                marginRight: '10px',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: isCurrent ? currentHourItemPadding : itemBasePadding,
                background: isCurrent ? '#e4299c' : 'transparent',
                borderRadius: '4px',
                // Removed transform: scale()
                transition: 'background-color 0.2s ease-in-out, padding 0.2s ease-in-out',
                flexShrink: 0,
              }}
            >
              <div style={{ fontSize: '18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                {Array.from({ length: emissionLevel }, (_, idx) => (
                  <img
                    key={idx}
                    src="/CO2.svg"
                    alt="Emission level"
                    style={{
                      width: `${isCurrent ? currentHourIconSize : iconBaseSize}px`,
                      height: `${isCurrent ? currentHourIconSize : iconBaseSize}px`,
                      transition: 'width 0.2s ease-in-out, height 0.2s ease-in-out',
                    }}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmissionTimeline;